import { useEffect, useRef, useState } from "react"
import { Navigate } from "react-router-dom"
import { appStore } from "../store/appStore"
import { useRequest } from "../hooks/useRequest"
import { resolveLocationSilently } from "../lib/locationResolve"
import Loader from "./Loader"
import Start from "../app/pages/Start"
import { hrefForCurrentCinema } from "../lib/cinemaSlugs"

/**
 * Развилка главной страницы: если город посетителя известен (выбран ранее или
 * тихо определён по геолокации) — открываем афишу, иначе показываем лендинг.
 */
export default function StartGate() {
    const locationSelected = appStore(s => s.locationSelected)
    const { requestData } = useRequest()
    const requestDataRef = useRef(requestData)
    requestDataRef.current = requestData

    const [resolving, setResolving] = useState(!locationSelected)

    useEffect(() => {
        if (locationSelected) return

        let cancelled = false
        resolveLocationSilently(requestDataRef.current)
            .catch(() => false)
            .then(() => {
                if (!cancelled) setResolving(false)
            })

        return () => {
            cancelled = true
        }
        // Попытка выполняется один раз при заходе на главную
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (locationSelected) return <Navigate to={hrefForCurrentCinema("/afisha")} replace />
    if (resolving) return <Loader frame />

    return <Start />
}
